import React from "react";
import { PTO_STATUS_MAP } from "./_common";

const PtoStatusLabel = (props) => {
    const { pto, hideLabel } = props;
    return pto ? <span title={PTO_STATUS_MAP[pto.statusCode].Label}><i className={PTO_STATUS_MAP[pto.statusCode].Icon}></i> { !!hideLabel ? "": PTO_STATUS_MAP[pto.statusCode].Label}</span> : null
};

export default PtoStatusLabel;